import React from 'react'
import {Actions} from 'jumpstate'
import {Col, Button} from 'react-bootstrap'
import HorseFinder from './HorseFinder'
import OwnerBox from '../HorseInfo/HorseBreederOwner/OwnerBox/OwnerBox'
import AdBox from '../HorseInfo/HorseBreederOwner/AdBox/AdBox'
import showToastr from '../../utils/showToastr'

class NewAd extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      horse: null,
      messages: ['آگهی برای کدام اسب؟', 'ثبت مالکیت', 'جزئیات آگهی را درج نمایید.', 'آگهی با موفقیت ثبت شد.'],
      step: 0,
      isOwnerBoxVisible: false,
      isAdBoxVisible: false
    }
    this.horseSetter = this.horseSetter.bind(this)
    this.ownerHandler = this.ownerHandler.bind(this)
    this.adHandler = this.adHandler.bind(this)
  }

  horseSetter (horse) {
    this.setState({horse, step: horse.isOwner ? 2 : 1})
  }

  ownerHandler (show = true) {
    if (!this.props.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isOwnerBoxVisible: show})
  }

  adHandler (show = true) {
    if (!this.props.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isAdBoxVisible: show})
  }

  render () {
    const {user} = this.props
    const {horse, step, messages} = this.state
    return (
      <div className="add-new-ad">
        {horse && <OwnerBox isVisible={this.state.isOwnerBoxVisible} toggler={this.ownerHandler} horse={horse} afterSave={() => this.setState({horse: {...horse, isOwner: true}, step: 2})} />}
        {horse && user && <AdBox isVisible={this.state.isAdBoxVisible} toggler={this.adHandler} horse={horse} user={user} afterSave={() => {
          this.props.toggler(false)
          this.props.afterSave()
        }} />}

        <h3>{messages[step]}</h3>
        <Col xs={12} className="center-block">
          <HorseFinder resultHandler={this.horseSetter} placeholder="نام اسب شما" />
          {step === 1 && <Button bsStyle="primary" className="BtnCenter" onClick={() => this.ownerHandler()}>من مالک این اسب هستم</Button>}
          {step === 2 && <Button bsStyle="success" className="BtnCenter" onClick={() => this.adHandler()}>آگهی {horse.name} را ثبت کنید.</Button>}
        </Col>

      </div>
    )
  }
}

NewAd.propTypes = {
  isAuthenticated: React.PropTypes.bool,
  user: React.PropTypes.object,
  toggler: React.PropTypes.func,
  afterSave: React.PropTypes.func
}

export default NewAd



// WEBPACK FOOTER //
// ./src/components/Ad/NewAd.js